import option1 from "@/public/images/option1.png";
import option2 from "@/public/images/option2.png";
import option3 from "@/public/images/option3.png";
import option4 from "@/public/images/option4.png";
import option5 from "@/public/images/option5.png";
import option6 from "@/public/images/option6.png";
import option7 from "@/public/images/option7.png";
import option8 from "@/public/images/option8.png";
import option9 from "@/public/images/option9.png";
import option11 from "@/public/images/option11.png";
import option12 from "@/public/images/option12.png";
import option14 from "@/public/images/option14.png";
import option15 from "@/public/images/option15.png";
import option16 from "@/public/images/option16.png";
import option17 from "@/public/images/option17.png";
import option18 from "@/public/images/option18.png";

export const DescList = [
  {
    title: "Pack sérénité",
    code: "NRFPC",
    description:
      "Franchise réduite à 300€. \
      Votre location inclut une assurance PACK BASIQUE qui ne couvre que les dommages causés à des tiers avec une franchise de 1200€ en cas d'accident, doublée en cas de vol. \
      Une franchise réduite de 1200€ à 90€ \
      En cas de bris de glace \
      Une couverture jusqu'à 300€ \
      En cas de perte ou vol des clés et papiers, dommages aux pneumatiques, erreur de carburant",
  },
  {
    title: "RENT A CAR ASSISTANCE 7J/7 - 24H/24",
    code: "ATM",
    description:
      "En cas de panne, d'accident, d'incendie, de vol ou vandalisme de votre véhicule de location, Rent A Car Assistance s'occupe de tout !",
  },
  {
    title: "CONDUCTEUR ADDITIONNEL",
    code: "CAD",
    description:
      "Partagez la conduite de votre véhicule de location pour plus de sécurité et de confort.",
  },
  {
    title: "SUPPLÉMENT JEUNE CONDUCTEUR",
    code: "CONDUCT",
    description:
      "Avec ce supplément, vous réduisez de 2 ans le nombre d'années de détention de permis de conduire nécessaire pour louer la catégorie choisie.",
  },
  {
    title: "SIÈGE RÉHAUSSEUR ENFANT",
    code: "REHAUSS",
    description: "De 15 à 35 kg (4-7 ans)",
  },
  {
    title: "SIÈGE BÉBÉ",
    code: "SIEGEBB",
    description: "Jusqu'à 9 kg (0-12mois)",
  },
  {
    title: "Siège ENFANT",
    code: "SIEGEENF",
    description: "De 9 à 15 kg (1-3 ans)",
  },
  {
    title: "DIABLE SIMPLE",
    code: "DIABLE",
    description:
      "Déplacez des charges lourdes dans tous les environnements (Ascenseurs, cages d'escalier...) ",
  },
  {
    title: "PACK DE 5 CARTONS",
    code: "CART1",
    description:
      "Pack de 5 cartons standards renforcés (Dimensions : 55 x 35 x 30 cm)",
  },
  {
    title: "PACK 10 CARTONS",
    code: "CART2",
    description:
      "Pack de 10 cartons standards renforcés (Dimensions : 55 x 35 x 30 cm)",
  },
  {
    title: "PACK DE 20 CARTONS",
    code: "CART3",
    description:
      "Pack de 20 cartons standards renforcés (Dimensions : 55 x 35 x 30 cm)",
  },
];

export const ImageList = [
  {
    codes: ["NSNRFPC", "NNRFPC", "LSNRFPC", "LXNRFPC"],
    image: option1,
  },
  {
    codes: ["NSATMP", "NATMP", "LSATMP", "LXATMP"],
    image: option2,
  },
  {
    codes: ["NSCONDUCT", "NCONDUCT", "LSCONDUCT", "LXCONDUCT"],
    image: option3,
  },
  {
    codes: ["NSSIEGEBB", "NSIEGEBB", "LSSIEGEBB", "LXSIEGEBB"],
    image: option4,
  },
  {
    codes: ["NSCAD", "NCAD", "LSCAD", "LXCAD"],
    image: option5,
  },
  {
    codes: ["NSSIEGEENF", "NSIEGEENF", "LSSIEGEENF", "LXSIEGEENF"],
    image: option6,
  },
  {
    codes: ["NSNANNUMOD", "NNANNUMOD", "LSNANNUMOD", "LXNANNUMOD"],
    image: option7,
  },
  {
    codes: ["NSATM", "NATM", "LSATM", "LXATM"],
    image: option8,
  },
  {
    codes: ["NSREHAUSS", "NREHAUSS", "LSREHAUSS", "LXREHAUSS"],
    image: option9,
  },
  {
    codes: ["NSNSATT", "LSNSATT"],
    image: option11,
  },
  {
    codes: ["NSCHAINES", "LSCHAINES"],
    image: option12,
  },
  {
    codes: ["NSLIVRREPR", "LSLIVRREPR"],
    image: option14,
  },
  {
    codes: ["NSABANDON", "LSABANDON"],
    image: option15,
  },
  {
    codes: ["LSGIROPH", "NSGIROPH"],
    image: option16,
  },
  {
    codes: ["NSPNEUSHIV", "LSPNEUSHIV"],
    image: option17,
  },
  {
    codes: ["NSGALERIE", "LSGALERIE"],
    image: option18,
  },
];

export const AutorisedSchemas = ["00"];
